import type { AllRouteEndpoints } from "../routeTypes";
export const alloysShopifyAppGroupIdBridgesBridgeIdCatalogResyncCacheKeys: AllRouteEndpoints[] = [
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id",
];
